/* eslint-disable */
// error handler

import BaseClient from './BaseClient';
import { arrayToMapById, isEmptyObject } from '../utils';

const DEFAULT_PARSE_ID_NAME = 'id';
const HEADERS = {
  IF_MATCH_HEADER: 'If-Match',
  LAST_MODIFIED_HEADER: 'X-LP-Last-Modified',
  E_TAG: "ETag",       //old version revision header
  AC_REVISION: "ac-revision",   //newer version revision header - used when services moves to nginx
};

/**
 * calculate meta data from the response data.
 * @param {Object} response - The response data.
 */
function calculateMeta(response) {
  let tempMeta = {};
  let meta;
  if (response) {
    if (response.headers[HEADERS.LAST_MODIFIED_HEADER] !== undefined) {
      tempMeta.lastModified = response.headers[HEADERS.LAST_MODIFIED_HEADER];
    }
    if (response.headers[HEADERS.AC_REVISION] !== undefined) {
      tempMeta.revision = response.headers[HEADERS.AC_REVISION];
    } else if (response.headers[HEADERS.E_TAG] !== undefined) {
      tempMeta.revision = response.headers[HEADERS.E_TAG];
    }
  }

  if (!isEmptyObject(tempMeta)) {
    meta = Object.assign({}, tempMeta);
  }
  return meta;
}

/**
 * Expand response data with meta data and map the response list by id.
 *
 * @param {Object} response - The response data.
 * @param {String} mapIdName - The list id name (default: 'id').
 */
function parseResponse(response, mapIdName) {
  response.parsed = {
    meta: calculateMeta(response),
  };

  if (response.data &&
    response.data.length > 0 &&
    Object.prototype.hasOwnProperty.call(response.data[0], mapIdName)) {
    response.parsed.map = arrayToMapById(response.data, mapIdName);
  }
  return response
}

/**
 * Enrich request data with AC headers.
 * @param {object} options - configuration object.
 */
function buildHeaders(options) {
  if(!(options && options.config)){
    return;
  }

  if (!options.config.headers) {
    options.config.headers = {};
  }

  if (options.config.revision === undefined) {
    options.config.headers[HEADERS.IF_MATCH_HEADER] = -1;
  } else {
    options.config.headers[HEADERS.IF_MATCH_HEADER] = options.config.headers.revision;
  }

  if (options.config[HEADERS.LAST_MODIFIED_HEADER] === undefined && options.config[HEADERS.LAST_MODIFIED_HEADER]) {
    options.config.headers[HEADERS.LAST_MODIFIED_HEADER] = options.config[HEADERS.LAST_MODIFIED_HEADER];
  }
}

/**
 * Create ACReadClient extends  BaseClient.
 * http client for AC.
 *
 * @param {Object} options - config object.
 * @param {String} options.mapIdName - map response list by id.
 * @param {String} options.config - conf object.
 * @param {String} options.config.baseURL - base url.
 * @param {String} options.config.headers - headers to load on request.
 *
 */
export default class ACReadClient extends BaseClient {
  constructor(options) {
    buildHeaders(options);
    super(options);
    this.loadResponseInterceptors(options);
    this.HEADERS = HEADERS;
    this.DEFAULT_PARSE_ID_NAME = DEFAULT_PARSE_ID_NAME;
  }

  loadResponseInterceptors(options) {
    const parseIdName = options.mapIdName || DEFAULT_PARSE_ID_NAME;
    this.useResponseInterceptor((response) => {
      return parseResponse(response, parseIdName);
    }, (error) => {
      return Promise.reject(error);
    });
  }
};



// WEBPACK FOOTER //
// ./src/api-layer/ACBaseClient.js